import { render, staticRenderFns } from "./RegistrarNegocio.vue?vue&type=template&id=50d9f316&scoped=true&"
import script from "./RegistrarNegocio.vue?vue&type=script&lang=js&"
export * from "./RegistrarNegocio.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarNegocio.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegistrarNegocio.vue?vue&type=style&index=1&id=50d9f316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d9f316",
  null
  
)

export default component.exports